import { render, staticRenderFns } from "./LoanOverdueWidget.vue?vue&type=template&id=236f67fc&scoped=true&"
import script from "./LoanOverdueWidget.vue?vue&type=script&lang=ts&"
export * from "./LoanOverdueWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236f67fc",
  null
  
)

export default component.exports